const activities = [
  {
    title: "Upcoming Math Exam",
    activities: [
      {
        title: 'ALGEBRA AND FUNCTIONS',
        timeline: [
          { date: '1 Jan', status: '☠️' },
          { date: '3 Jan', status: '🤨' },
          { date: '5 Jan', status: '🙂' },
          { date: '6 Jan', status: '😃' },
          { date: '7 Jan', status: '🎉' },
        ],
      },
      {
        title: 'COORDINATE GEOMETRY',
        timeline: [
          { date: '1 Jan', status: '🙂' },
          { date: '6 Jan', status: '😃' },
          { date: '7 Jan', status: '🎉' },
        ],
      },
      {
        title: 'DIFFERENTIATION AND INTEGRATION',
        timeline: [
          { date: '2 Jan', status: '🤷' },
          { date: '4 Jan', status: '🤨' },
          { date: '5 Jan', status: '🙂' },
          { date: '6 Jan', status: '😃' },
          { date: '7 Jan', status: '😬' },
          { date: '8 Jan', status: '🎉' },
        ],
      }
    ]
  }
]
export default activities;
